import styled from 'styled-components';

export const Wrapper = styled.section`
	display: flex;
	flex-direction: column;
`;

export const Container = styled.div`
	padding: 0 32px 24px 32px;
`;
